import { ContractFamilyInfo } from "@store/authAtoms"

export type UserDto = {
  active: boolean
  creation_date: string
  creator_email: string
  first_name: string
  key: string
  last_name: string
  last_updated: string
  last_login: string
  organisation_key: string
}

export type UsersDto = {
  items: UserDto[]
  total: number
}

export type UpdateUserDto = {
  key: string
  organisation_key: string
  first_name: string
  last_name: string
  active: boolean
  last_updated: string
  last_login: string
}

export enum UserRole {
  ADMIN = "admin",
  BUILDER = "build",
  SUPPORT = "support",
  TEMPLATE = "template",
  VIEWER = "viewer",
  WHATIF = "whatif",
}

export type UserPermissions = {
  [key in UserRole]?: ContractFamilyInfo[]
}
